<pr-form
  (onSubmit)="onSubmit()"
  title="VOTRE PORTFEUILLE SUR MESURE "
  [formGroup]="form"
>
  <pr-color-panel [display]="allocationPanel.display">
    <pr-panel-body clazz="pam">
      <pr-label [name]="allocationPanel.icon" [width]="18" [height]="18">{{
        allocationPanel.text
      }}</pr-label>
    </pr-panel-body>
  </pr-color-panel>

  <pr-table-form
    #tableForm
    [formGroup]="allocation"
    [addButtonLabel]="'Ajouter un nouveau support'"
    swiperMinWidth="768"
    (onSelectClick)="openSupportsForm()"
    [columnsDefinition]="columnsDefinition"
    [formatTable]="formatTableDataFunction()"
    [createModelDefinition]="createModel"
    (optionSelected)="newOptionLogic()"
  >
  </pr-table-form>

  <pr-subform
    #supportsForm
    [formGroup]="form"
    [context]="this"
    (onOpen)="_defaultAllocationFormValue = form.value"
    (onCancel)="cancelManageAllocationform()"
    (onValidate)="validManageAllocationform()"
  >
    <ng-container formContent>
      <h4 class="fs-28 bold mbn mtl">Choisissez librement vos supports.</h4>
      <span class="text-secondary fs-14">Un contrat à votre image.</span>

      <form [formGroup]="criteriaForm">
        <pr-input-abstract
          label="Type de support"
          class="mvl"
          style="display: block"
        >
          <mat-select formControlName="supportTypes" placeholder="Tous">
            <mat-option [value]="undefined">Tous</mat-option>
            @for (type of supportTypes; track type) {
              <mat-option [value]="type.id">
                {{ type.value }}
              </mat-option>
            }
          </mat-select>
        </pr-input-abstract>

        <pr-search-input
          formControlName="autocomplete"
          placeholder="Recherchez un fond"
          class="mbm"
        >
        </pr-search-input>
      </form>

      <pr-form-select-list #formSelectList>
        @for (support of supports; track support) {
          <pr-form-select-list-option
            [label]="support.name"
            [labelIcon]="support.favorite ? 'sp-cup' : undefined"
            [subLabel]="support.isin"
            [selected]="
              _.map(form.get('allocation').value, 'isin').includes(support.isin)
            "
            [criterias]="[
              {
                label: 'Performance',
                value: '~',
                options: { color: 'success' },
              },
              { label: 'Niveau de risque', value: '~' },
            ]"
            (onSelect)="onSupportSelect(support)"
            (onDeselect)="onSupportDeselect(support)"
            [withMoreInfoAnchor]="support.id"
            (onMoreInfoClick)="onMoreInfoClick(support)"
          >
          </pr-form-select-list-option>
        }
      </pr-form-select-list>
      <mat-paginator
        [length]="supportsLength"
        [pageSize]="supportsPageSize"
        (page)="changeSupportsPage($event)"
      >
      </mat-paginator>
    </ng-container>
  </pr-subform>
</pr-form>
